module.exports = __webpack_public_path__ + "static/media/logo.c270e74b.webp";